module.exports = __webpack_public_path__ + "static/media/gg.02df8a5d.svg";